/// <amd-module name="typeahead/core/geolocation/MercuryGeolocationViewController" />
/// <amd-dependency path="typeahead/core/loc" name="loc"/>

import {GeolocationDataProvider, IPosition} from "typeahead/core/geolocation/GeolocationDataProvider";
import {GeolocationViewController} from "typeahead/core/geolocation/GeolocationViewController";
import {GeolocationClearedMessage} from "typeahead/core/geolocation/message/GeolocationClearedMessage";
import {IDataProviderResponse} from "typeahead/core/IDataProvider";
import {FormSubmittedMessage} from "typeahead/core/message/FormSubmittedMessage";
import {SubmitClickedMessage} from "typeahead/core/message/SubmitClickedMessage";
import {SuggestionAutoSelectedMessage} from "typeahead/core/message/SuggestionAutoSelectedMessage";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import * as SearchParametersUpdater from "typeahead/core/SearchParametersUpdater";
import {ISuggestionResult} from "typeahead/core/Suggestion";
import * as SuggestionFactory from "typeahead/core/SuggestionFactory";

export class MercuryGeolocationViewController extends GeolocationViewController {

    constructor(protected geolocationDataProvider: GeolocationDataProvider) {
        super(geolocationDataProvider);
        TypeaheadMessage.subscribe(SubmitClickedMessage.getTopic(),
            (topic: string, message: SubmitClickedMessage) => {
                if (this.isGeolocationSuggestionSelected(this.getVisibleTypeaheadDivElement())) {
                    if (!this.isGeolocationAvailable()) {
                        if (message.getEvent()) {
                            message.getEvent().preventDefault(); // stop submit
                        }
                        this.geolocationDataProvider.findGeolocation(this.getVisibleTypeaheadDivElement().find(
                            "input[data-gcw-storeable-name=gcw-destination]").attr("id"),
                            $(message.getEvent().currentTarget));
                    } else {
                        this.disableLocalStorage();
                    }
                }
            });
        TypeaheadMessage.subscribe(FormSubmittedMessage.getTopic(),
            (topic: string, message: FormSubmittedMessage) => {
                if (message.isFormValid() &&
                        this.isGeolocationSuggestionSelected(this.getVisibleTypeaheadDivElement())) {
                    let $form: JQuery = $("form:has(input[data-provide=utypeahead]):visible");
                    $form.append($("<input>").attr("type", "hidden").attr("name", "sort").val("distance"));
                }
            });
        TypeaheadMessage.subscribe(GeolocationClearedMessage.getTopic(),
            (topic: string, message: GeolocationClearedMessage) => {
                this.updateSearchParameters(message.getGeolocationResult(), $("#" + message.getDomElementId()));
            });
    }

    // On Mobile device, show current location, if no previous search or previous search was current location
    public handlePageLoad(context: IContext, mustPopulateCurrentLocationText: boolean): void {
        this.geolocationDataProvider.fetchData(undefined).done((response: IDataProviderResponse) => {
            let suggestionResult: ISuggestionResult = <ISuggestionResult> response.results[0];
            let $inputElement: JQuery =
                $(`form[data-lob-form=` + context.tab + `]`).find("input[data-gcw-storeable-name=gcw-destination]");
            let $autoCompleteDiv: JQuery = $inputElement.closest("div.autocomplete");
            if ($autoCompleteDiv.length) {

                // If explicit request for populating current location text
                // OR If it is not activity tab
                if (    mustPopulateCurrentLocationText
                        || ( context.tab !== "activity" &&
                                (this.isGeolocationCategory($autoCompleteDiv) || !$inputElement.val())
                        )
                ) {
                    this.populateCurrentLocationSearchContext($inputElement, suggestionResult);
                }
            }
        });
    }

    protected isGeolocationAvailable(): boolean {
        return this.getVisibleTypeaheadDivElement().find("[id*=lat_long]").val();
    }

    protected updateSearchParameters(suggestionResult: ISuggestionResult, $element: JQuery) {
        SearchParametersUpdater.updateForSuggestion(undefined,
            SuggestionFactory.createSuggestion(suggestionResult), $element.data(), $element.attr("id"));
    }

    private isGeolocationCategory($typeaheadDivElement: JQuery): boolean {
        return GeolocationDataProvider.CATEGORY === $typeaheadDivElement.find("[id*=category]").val();
    }

    private isGeolocationSuggestionSelected($typeaheadDivElement: JQuery): boolean {
        return GeolocationDataProvider.CATEGORY === $typeaheadDivElement.find("[id*=region_type]").val();
    }

    private getVisibleTypeaheadDivElement(): JQuery {
        return $("div.autocomplete:visible");
    }

    private disableLocalStorage(): void {
        this.getVisibleTypeaheadDivElement().find(".gcw-storeable").not("[id*=category]").each((index, element) => {
            $(element).removeClass("gcw-storeable");
        });
    }

    private populateCurrentLocationSearchContext($inputElement: JQuery, suggestionResult: ISuggestionResult): void {
        $inputElement.val(suggestionResult.regionNames.lastSearchName);
        this.updateSearchParameters(suggestionResult, $inputElement);
        TypeaheadMessage.publish(new SuggestionAutoSelectedMessage(
            SuggestionFactory.createSuggestion(suggestionResult), $inputElement.attr("id")));
    }
}
